import { defineStore } from 'pinia'
import { lock } from './../api'
import { ref } from '@nuxtjs/composition-api'

export const usePayModel = defineStore('pay', () => {
  const status = ref<boolean>(false)

  const getStatus = async (payload: { restaurant: string, tableId: string }): Promise<boolean> => {
    const { restaurant, tableId } = payload
    const res = await lock(restaurant, tableId)
    let lockStatus = false

    if (res.stub_types.length) {
      if (res.stub_types.includes('PAYMENT') || (res.stub_types.includes('PAYMENT') && res.stub_types.includes('SBP')) || res.stub_types.includes('WITHOUT_TIPS')) {
        lockStatus = true
      }
    }
    status.value = lockStatus
    return lockStatus
  }

  return {
    status,
    getStatus
  }
})
